import type { ColumnDef } from "@/components/SortableTable";
import { DeepLink } from "@/components/DeepLink";
import { Pill, type PillTone } from "@/components/ui";
import { t } from "@/i18n";
import { fmtInt } from "@/lib/utils";

import type { DenetimBulguRow } from "./rows";
import { SIDDET_LABEL_KEY, SIDDET_ORDER, TUR_LABEL_KEY } from "./severity";

const SIDDET_TONE: Record<string, PillTone> = {
  yuksek: "bad",
  orta: "warn",
  dusuk: "muted",
};

function SiddetBadge({ row }: { row: DenetimBulguRow }) {
  return <Pill tone={SIDDET_TONE[row.siddet]}>{t(SIDDET_LABEL_KEY[row.siddet])}</Pill>;
}

/** Bulgular tablosu — tur/urun/aciklama/siddet sutunlari (sozlesme §2). */
export function getBulguColumns(): ColumnDef<DenetimBulguRow>[] {
  return [
    {
      key: "tur",
      header: t("denetim.col.tur"),
      accessor: (row) => t(TUR_LABEL_KEY[row.tur]),
      sortValue: (row) => t(TUR_LABEL_KEY[row.tur]),
    },
    {
      key: "urun",
      header: t("denetim.col.urun"),
      accessor: (row) => (
        <div>
          <DeepLink href={row.admin_link} label={row.ad || "—"} />
          {row.stok != null && <div className="text-xs text-muted">{t("denetim.col.stok")}: {fmtInt(row.stok)}</div>}
        </div>
      ),
      sortValue: (row) => (row.ad || "").toLowerCase(),
    },
    {
      key: "aciklama",
      header: t("denetim.col.aciklama"),
      accessor: (row) => (
        <span className="block max-w-xs text-xs text-muted">
          {row.kanit || row.mevcut_ozellik_degeri || t("denetim.tanimsiz")}
        </span>
      ),
    },
    {
      key: "siddet",
      header: t("denetim.col.siddet"),
      accessor: (row) => <SiddetBadge row={row} />,
      sortValue: (row) => SIDDET_ORDER[row.siddet],
    },
  ];
}
